module.exports = __webpack_public_path__ + "img/magglass.132c8086.svg";